import React from "react";

const Brand = () => {
  return (
    <div className="bg-sky-50">
      <div className="container lg:max-w-[1280px]">
        <div className="grid grid-cols-3 lg:grid-cols-5 justify-items-center p-8 gap-8">
          <img
            className=" max-w-[130px] h-[30px] object-contain w-full"
            src="/assets/brand01.webp"
            alt="brand1"
          />
          <img
            className=" max-w-[130px] h-[30px] object-contain w-full"
            src="/assets/brand02.webp"
            alt="brand1"
          />
          <img
            className=" max-w-[130px] h-[30px] object-contain w-full"
            src="/assets/brand03.webp"
            alt="brand1"
          />
          <img
            className=" max-w-[130px] h-[30px] object-contain w-full"
            src="/assets/brand04.webp"
            alt="brand1"
          />
          <img
            className=" max-w-[130px] h-[30px] object-contain w-full"
            src="/assets/brand05.webp"
            alt="brand1"
          />
        </div>
      </div>
    </div>
  );
};

export default Brand;
